import React,{useState} from 'react'
import { useSelector,useDispatch } from "react-redux"
import { envAwarePost } from "../../../util/util"
import classes from "../FoodList.module.css";
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import MAXPortionOptions from '../../MAXPortionOptions/MAXPortionOptions'
import {deleteFood} from '../../../state/foodLibrary'
import {replaceEventData} from '../../todaysEvents/TodaysEventsSlice'
import useApiStatusDispatch from '../../../hooks/useApiStatusDispatch'
import FoodPortionSelect from '../../FoodPortionSelect/FoodPortionSelect'

const FoodRow = ({food,fillEditData,handleFoodModalOpen,isDeleting,foodRef}) =>{
	//Getting User
	const [isApplying,setIsApplying] = useState(false)
	const user = useSelector((state) => state.users.current_user);
	const dispatch = useDispatch()
	const isOwner = food.owner_type === user.account_type
	const statusDispatch = useApiStatusDispatch()
	const isClient = user.account_type === 'client'

	return (
		<tr>
			<td style={user.isMAXUser || !isOwner ? null : {cursor:"pointer"}}
				onClick={() => {
					if (user.isMAXUser || !isOwner) {
						return;
					}
					console.log(food)
					fillEditData(food);
					handleFoodModalOpen();
				}}>
				<div>{food.food_db_name}</div>
				<div>
					<small>
						{[food.brand_name,food.subbrand_name,food.brand_owner].filter(s=>Boolean(s)).join(' | ')}
					</small>
				</div>
				<div className="d-flex justify-content-between align-items-center flex-wrap">
					{!Boolean(user.isMAXUser)&&
						<FoodPortionSelect portions={food.portions}/>
					}
					{(user.isMAXUser===1&&isClient)&&
						<MAXPortionOptions 
							disabled={isApplying}
							onPortionSelect={(multiplier)=>{
								setIsApplying(true)
								envAwarePost('api/events/api/',{
									action:'logMAXFoodMacros',
									food_id:food.id,
									normalize:1,
									multiplier,
								}).then(res=>{
									setIsApplying(false)
									dispatch(replaceEventData({
										event_type:'nutrition',
										event:res.data,
									}))
								})
							}}>
								<Button 
									className="ml-auto my-1 my-sm-0"
									variant="outline-success"
									size="sm"
									disabled={isApplying}>
									{
										isApplying?
										<div>
											<Spinner 
												animation="border"
												className="mr-2"
												size="sm"
											/>
											please wait
										</div>:
										"Add to Nutrition"
									}
								</Button>
						</MAXPortionOptions>
					}
				</div>
			</td>
		{!user?.isMAXUser && isOwner && (
			<td>
				<div
					className={classes.DeleteIcon}
					style={
						isDeleting
						? { cursor: "wait" }
						: { cursor: "pointer" }
					}
					onClick={(e) => {
						if (isDeleting) {
							return;
						}
						if(!window.confirm(`Are you sure you want to delete ${food.food_db_name}?`)) return
						statusDispatch(deleteFood({
							selector: "food",
							user_id_number: user.user_id_number,
							item_db_id: food.food_db_id,
							defaultItem: food.defaultItem,
							operation: "delete",
					    }),'food','delete')
						foodRef.current = e.target;
						foodRef.current.innerHTML = "Deleting";
					}}>
					X
				</div>
			</td>
		)}
		</tr>
	)
}

export default FoodRow